import { render, staticRenderFns } from "./PaperlessPathTree.vue?vue&type=template&id=507cdbc4"
import script from "./PaperlessPathTree.vue?vue&type=script&lang=js"
export * from "./PaperlessPathTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports